<app-page-breadcrumb [breadcrumbs]="breadcrumbs" />
<p-toast />
<p-confirmdialog />

<div class="space-y-6">
  <div
    class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]"
  >
    <div
      class="flex flex-col gap-3 px-6 py-5 sm:flex-row sm:items-center sm:justify-between"
    >
      <div>
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white/90">
          Active Sessions
        </h2>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Devices currently signed in to your account. Revoking a session
          signs that device out immediately.
        </p>
      </div>
      @if (sessions.length > 1) {
        <button
          pButton
          type="button"
          label="Sign out all other sessions"
          icon="pi pi-sign-out"
          class="p-button-sm p-button-danger p-button-outlined"
          [loading]="revokingOthers"
          [disabled]="loading || revokingOthers"
          (click)="confirmRevokeOthers()"
        ></button>
      }
    </div>

    @if (loading) {
      <div class="flex items-center justify-center px-6 py-14">
        <i class="pi pi-spin pi-spinner text-2xl text-gray-400"></i>
      </div>
    } @else if (!sessions.length) {
      <div class="px-6 pb-10 text-center">
        <div
          class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 dark:bg-white/[0.06]"
        >
          <i class="pi pi-desktop text-xl text-gray-400"></i>
        </div>
        <p class="mt-4 text-sm font-semibold text-gray-700 dark:text-gray-200">
          No active sessions
        </p>
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Sessions appear here after you sign in on a device.
        </p>
      </div>
    } @else {
      <div class="max-w-full overflow-x-auto relative">
        <table class="min-w-full border-collapse">
          <thead
            class="bg-gray-50 dark:bg-white/[0.03] border-y border-gray-200 dark:border-white/[0.06]"
          >
            <tr>
              <th
                class="px-6 py-3 font-medium text-gray-600 text-left text-sm whitespace-nowrap dark:text-gray-400"
              >
                Device
              </th>
              <th
                class="px-4 py-3 font-medium text-gray-600 text-left text-sm whitespace-nowrap dark:text-gray-400"
              >
                IP Address
              </th>
              <th
                class="px-4 py-3 font-medium text-gray-600 text-left text-sm whitespace-nowrap dark:text-gray-400"
              >
                Signed In
              </th>
              <th
                class="px-4 py-3 font-medium text-gray-600 text-left text-sm whitespace-nowrap dark:text-gray-400"
              >
                Last Active
              </th>
              <th
                class="px-4 py-3 font-medium text-gray-600 text-left text-sm whitespace-nowrap dark:text-gray-400"
              >
                Status
              </th>
              <th
                class="px-4 py-3 font-medium text-gray-600 text-right text-sm whitespace-nowrap dark:text-gray-400"
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
            @for (s of sessions; track s.id) {
              <tr class="hover:bg-gray-50 dark:hover:bg-white/[0.02] transition">
                <td class="px-6 py-3.5 text-sm">
                  <div class="flex items-center gap-3">
                    <div
                      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-indigo-100 text-indigo-600 dark:bg-indigo-500/15 dark:text-indigo-300"
                    >
                      <i [class]="deviceIcon(s)"></i>
                    </div>
                    <div>
                      <p
                        class="font-medium text-gray-800 dark:text-white/90 whitespace-nowrap"
                      >
                        {{ deviceTitle(s) }}
                      </p>
                      <p class="text-xs text-gray-500 dark:text-gray-400">
                        {{ s.device_type | titlecase }} •
                        {{ s.auth_type === 'sso' ? 'SSO' : 'Password' }} login
                      </p>
                    </div>
                  </div>
                </td>
                <td
                  class="px-4 py-3.5 text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap"
                >
                  {{ s.ip_address || '—' }}
                </td>
                <td
                  class="px-4 py-3.5 text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap"
                >
                  {{ s.created_at | date: 'medium' }}
                </td>
                <td
                  class="px-4 py-3.5 text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap"
                >
                  {{ s.last_active_at | date: 'medium' }}
                </td>
                <td class="px-4 py-3.5 text-sm whitespace-nowrap">
                  @if (s.is_current) {
                    <span
                      class="rounded-full bg-green-100 px-2.5 py-0.5 text-xs font-medium text-green-700 dark:bg-green-500/15 dark:text-green-300"
                    >
                      This device
                    </span>
                  } @else {
                    <span
                      class="rounded-full bg-indigo-100 px-2.5 py-0.5 text-xs font-medium text-indigo-700 dark:bg-indigo-500/15 dark:text-indigo-300"
                    >
                      Active
                    </span>
                  }
                </td>
                <td class="px-4 py-3.5 text-sm text-right whitespace-nowrap">
                  <button
                    pButton
                    type="button"
                    label="Revoke"
                    icon="pi pi-times"
                    class="p-button-sm p-button-danger p-button-outlined"
                    [loading]="revokingId === s.id"
                    [disabled]="!!revokingId"
                    pTooltip="Sign this device out"
                    tooltipPosition="top"
                    (click)="confirmRevoke(s)"
                  ></button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
